module.exports = __webpack_public_path__ + "static/media/11.240fe1fc.jpg";